"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortGroupData = sortGroupData;
exports.getDestinationContentKeys = getDestinationContentKeys;
exports.updateGroupData = updateGroupData;
/**
 * Re-order group Data based on the order of groupKeys
 * @param groupData - An array of groupData.
 * @param groupKeys - An array of groupKeys.
 * @returns sortedGroupData - New re-arranged groupData
 */

function sortGroupData(groupData, groupKeys) {
    var sortedGroupData = [];
    if (groupData) {
        groupData.forEach(function (group) {
            var index = groupKeys.findIndex(function (groupKey) {
                return groupKey === group.groupKey;
            });
            index < 0 ? index = groupData.length - 1 : null;
            sortedGroupData[index] = group;
        });
    }
    return sortedGroupData;
}

// ----------------------------------------------------- MOVING CONTENT HELPERS ------------------------------------------------------------
/**
 * Finds the group data object matching the destination group key and concatenates the content keys to that group data.
 * @param destGroupKey - Group Key of the group that will have contents moved to it.
 * @param contentKeys - The content keys to be moved to a group.
 * @param groupData - The Group data array represented in the state.
 * @returns A combined {Array} of all content keys in the destination group or empty if no match found.
 */
function getDestinationContentKeys(destGroupKey, contentKeys, groupData) {
    if (!destGroupKey || !contentKeys || !groupData) {
        return [];
    }
    var destGroupData = groupData.find(function (element) {
        return element.groupKey === destGroupKey;
    });
    return destGroupData && destGroupData.contentKeys ? destGroupData.contentKeys.concat(contentKeys) : [];
}

/**
 * Removes content keys from the src group data and adds content keys to the destination group data.
 * @param groupData - The Group data array represented in the state.
 * @param contentKeysToMove - The content keys to be moved to a group.
 * @param srcGroupKey - Group Key of the group that is having contents moved to another group.
 * @param destGroupKey - Group Key of the group that will have contents moved to it.
 * @param combinedContentKeys - A combined {Array} of all content keys in the destination group after the move.
 */
function updateGroupData(groupData, contentKeysToMove, srcGroupKey, destGroupKey, combinedContentKeys) {
    if (!groupData || !contentKeysToMove || !combinedContentKeys) {
        return;
    }
    groupData.forEach(function (item) {
        if (item.groupKey === srcGroupKey) {
            contentKeysToMove.forEach(function (contentKey) {
                item.contentKeys.splice(item.contentKeys.indexOf(contentKey), 1);
            });
        }
        if (item.groupKey === destGroupKey) {
            item.contentKeys = combinedContentKeys;
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/groups-helper.js
// module id = 763
// module chunks = 0